import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["title", "footer", "width", "loading", "cancelText", "okText", "onCancel", "onOk", "cancelButtonProps", "okButtonProps", "wrapClassName", "preventCancel", "className", "children"],
  _excluded2 = ["width", "className", "contentOnly"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Modal } from 'antd';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import DixuSpin from "../DixuSpin/DixuSpin";
import DixuText from "../DixuText/DixuText";
import { useTranslation } from "../../i18n";
import React from 'react';
import { toRem } from "../../utils/Utils";
const commonClassNames = ['dixu-modal'];
const DixuModal = _ref => {
  let {
      title,
      footer,
      width,
      loading,
      cancelText,
      okText,
      onCancel,
      onOk,
      cancelButtonProps,
      okButtonProps,
      wrapClassName,
      preventCancel,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation(['common']);
  const classes = classNames(commonClassNames, className);
  const wrapperClasses = classNames('dixu-modal-wrapper', wrapClassName);
  const renderedTitle = (() => {
    if (typeof title === 'string') {
      return /*#__PURE__*/React.createElement(DixuText, {
        font: '3',
        color: '2-9',
        weight: 'bold'
      }, title);
    }
    return title;
  })();
  const handleCancel = () => {
    if (preventCancel || loading) {
      return;
    }
    onCancel?.();
  };
  const renderedFooter = (() => {
    if (typeof footer !== 'undefined') {
      return footer;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuButton.Group, {
      justify: "end",
      spacing: "sm"
    }, /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
      type: 'outline',
      onClick: handleCancel,
      disabled: preventCancel || loading
    }, cancelButtonProps), cancelText || t('common:Cancel')), /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
      type: 'primary',
      onClick: onOk,
      loading
    }, okButtonProps), okText || t('common:Ok'))));
  })();
  return /*#__PURE__*/React.createElement(Modal, _objectSpread({
    className: classes,
    wrapClassName: wrapperClasses,
    centered: true,
    title: renderedTitle,
    footer: renderedFooter,
    width: toRem(width),
    onCancel: handleCancel,
    onOk
  }, rest), /*#__PURE__*/React.createElement(DixuSpin, {
    spinning: loading
  }, children));
};
DixuModal.defaultProps = {
  title: undefined,
  closeIcon: undefined,
  footer: undefined,
  destroyOnClose: true,
  width: 520,
  loading: false,
  preventCancel: false
};
const commonMethodDefaults = {};
const info = _ref2 => {
  let {
      width,
      className,
      contentOnly
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return Modal.info(_objectSpread(_objectSpread({
    className: classNames(commonClassNames, {
      'dixu-modal--content-only': contentOnly
    }, className),
    width: toRem(width)
  }, commonMethodDefaults), rest));
};
DixuModal.info = info;
export default DixuModal;